<template>
  <div class="space-y-10 flex flex-col text-gray_light">
    <Logo class="self-center text-left mt-6 w-64 cursor-pointer" @click="$router.go(-1)"/>
    <div class="space-y-4">
      <p class="mx-24 font-light">Necesitamos tu información para reservas y para participar en colaboraciones por delivery</p>

      <div class="px-4">
        <div class="overflow-hidden rounded-md w-full flex justify-between items-center px-2 bg-white text-black">
          <label for="phone" class="text-onboarding_light_gray flex-none font-bold py-3 items-center">+</label>
          <input
            id="phone"
            type="text"
            maxlength="17"
            v-model="newPhone"
            class="rounded-md px-4 py-2 w-full"
            placeholder="Teléfono para reserva *"
            style="width: 100% !important; border: none !important;">
<!--            @keydown="phoneFormatter($event)">-->
          <!--Mask
            id="phone"
            v-model="newPhone"
            class="inline-block text-lg"
            style="width: 100% !important;"
            placeholder="Teléfono para reserva *"
            @change="phoneFormatter($event)"
            @keypress.delete="newPhone = ''"
            @focus="phoneAux = ''"
            mask="999999999"/-->
        </div>
      </div>

<!--      <p class="mx-12 font-light">Si quieres participar en colaboraciones de delivery, rellena tu dirección</p>-->
      <div class="mt-2 flex flex-col w-full px-4 text-black">
        <input
          type="text"
          placeholder="Dirección *"
          :value="address"
          @input="$emit('update:address', $event.target.value)"
          class="border rounded-md px-4 py-2 w-full">
      </div>
      <div class="flex w-full px-4 text-black">
        <input
          type="text"
          placeholder="Ciudad"
          :value="city"
          @input="$emit('update:city', $event.target.value)"
          class="border rounded-md px-4 py-2 mr-2 flex-1">
        <input
          type="text"
          :value="state"
          placeholder="Estado/Provincia/Región"
          @input="$emit('update:state', $event.target.value)"
          class="border rounded-md px-4 py-2 flex-1 disabled:bg-gray_light">
<!--        <select id="companionSelectorSS" class="flex-1 border ml-2 p-1 rounded px-2" v-model="cstate" @change="$emit('update:state', $event.target.value)">-->
<!--          <option v-for="province in provinces" :key="province" :value="province">{{ province }}</option>-->
<!--          <option value="madrid">Madrid</option>-->
<!--          <option value="barcelona">Barcelona</option>-->
<!--          <option value="sevilla">Sevilla</option>-->
<!--          <option value="bilbao">Bilbao</option>-->
<!--          <option value="valencia">Valencia</option>-->
<!--          <option value="málaga">Málaga</option>-->
<!--          <SearchSelect />-->
<!--        </select>-->
      </div>
<!--      <div class="flex w-full px-4 text-black">-->
<!--        <input-->
<!--          type="number"-->
<!--          :value="zip_code"-->
<!--          placeholder="Código postal"-->
<!--          @input="$emit('update:zip_code', $event.target.value)"-->
<!--          class="border rounded-md px-4 py-2 mr-2 flex-1">-->
<!--        <input-->
<!--          disabled-->
<!--          type="text"-->
<!--          value="España"-->
<!--          class="border rounded-md px-4 py-2 ml-2 flex-1 disabled:bg-gray_light">-->
<!--      </div>-->
      <div class="flex w-full px-4 gap-2 text-black">
        <div class="flex-1 w-full">
          <input
            type="number"
            placeholder="Código postal"
            :value="zip_code"
            @input="$emit('update:zip_code', $event.target.value)"
            class="border flex-1 rounded-md py-2 flex-1">
        </div>
        <SearchSelect
          class="flex-1 custom-search-input"
          :country_iso="country_iso"
          style="border-radius: 6px !important;"
          :same-address-input="false"
          @selected-country="setCountry"/>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/logos/logo-white'
import SearchSelect from '@/components/ui/SearchSelect'
// import Mask from 'primevue/inputmask'
// TODO ACOMODAR EL LOADER PERPETUO CUANDO NO SE HA INGRESADO LA DIRECCION
export default {
  name: 'step-5',
  components: {
    SearchSelect,
    Logo
    // Mask
  },
  props: {
    phone: { required: false, type: String, default: '' },
    address: { required: false, type: String, default: '' },
    city: { required: false, type: String, default: '' },
    state: { required: false, type: String, default: '' },
    zip_code: { required: false, type: String, default: '' },
    country: { required: false, type: String, default: '' },
    country_iso: { required: false, type: String, default: '' }
  },
  emits: ['update:phone', 'update:address', 'update:city', 'update:state', 'update:zip_code'],
  data: () => ({
    newPhone: '',
    cstate: '',
    provinces: [
      'Albacete', 'Almería', 'Alicante', 'Andorra', 'Asturias', 'Avila', 'Badajoz', 'Barcelona',
      'Bilbao', 'Burgos', 'Cáceres', 'Cádiz', 'Cartagena', 'Castellón', 'Ceuta', 'Ciudad Real',
      'Córdoba', 'Cuenca', 'Elche', 'Gijón', 'Girona', 'Granada', 'Gran Canaria', 'Guadalajara',
      'Huelva', 'Ibiza', 'Jaén', 'La Coruña', 'León', 'Lérida', 'Logroño', 'Madrid', 'Mallorca',
      'Málaga', 'Melilla', 'Menorca', 'Murcia', 'Navarra', 'Oviedo', 'Palencia', 'Pamplona',
      'Pontevedra', 'Salamanca', 'San Sebastián', 'Santander', 'Segovia', 'Sevilla', 'Soria',
      'Tarragona', 'Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vigo', 'Zamora', 'Zaragoza'
    ]
  }),
  methods: {
    phoneFormatter (e) {
      const numberRegex = /^\d+$/
      if (!numberRegex.test(e.key)) {
        e.preventDefault()
      } else {
        const aux = this.newPhone.replace(/\D/g, '')
        this.$emit('update:phone', aux)
      }
    },
    setCountry (e) {
      if (e) {
        this.$emit('update:country', e.text)
        this.$emit('update:country_iso', e.value)
      }
    }
  },
  watch: {
    newPhone (val) {
      // this.newPhone = val.replace(/^\d+$/g, '')
      const aux = val.replace(/\D/g, '')
      this.newPhone = aux
      this.$emit('update:phone', aux)
    }
  },
  mounted () {
    this.newPhone = this.phone
    this.cstate = this.state
  }
}
</script>
<style scoped>
#phone{
  height: 48px !important;
  border: none;
  border-radius: 0 !important;
  padding: 0 2px;
  line-height: 48px;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  text-align: left !important;
  font-size: 14px !important;
}
#phone:focus {
  outline: 0 none;
  box-shadow: none;
}
.p-inputtext{
  background-color: #fff !important;
}
</style>
